import { capitalize } from 'lib/formatters/typed_strings';

import { MocksWithUniqueNames } from './named_mocks';

import type {
  BaseQueryFn,
  EndpointDefinitions,
  Module,
} from '@reduxjs/toolkit/query/react';

// Import buildMocks only in Jest to avoid bundling node-only MSW code in browser assets.
let buildMocks: typeof import('./build_mocks').buildMocks | undefined;
if (process.env.JEST_WORKER_ID !== undefined) {
  buildMocks = require('./build_mocks').buildMocks;
}

export const tackleBoxModuleName = 'tackleBox';
export type TackleBoxModule = typeof tackleBoxModuleName;

declare module '@reduxjs/toolkit/query' {
  export interface ApiModules<
    BaseQuery extends BaseQueryFn,
    Definitions extends EndpointDefinitions,
    ReducerPath extends string,
    TagTypes extends string,
  > {
    tackleBox: {} & MocksWithUniqueNames<Definitions>;
  }
}

export const tackleBoxModule = (): Module<TackleBoxModule> => ({
  name: 'tackleBox',
  init(api, _options, _context) {
    const { buildQueryMock } = buildMocks?.() ?? { buildQueryMock: undefined };

    return {
      injectEndpoint(endpointName, definition) {
        const typedDefinition = definition as typeof definition & {
          mockRoute?: string;
        };

        if (typedDefinition.mockRoute && definition.type === 'query') {
          const mockQuery = buildQueryMock?.(typedDefinition.mockRoute);

          if (mockQuery) {
            // oxlint-disable-next-line no-param-reassign
            (api as unknown as Record<string, unknown>)[
              `mock${capitalize(endpointName)}`
            ] = mockQuery;
          }
        }
      },
    };
  },
});
